import { Box, Button, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Schedules from "./Schedules";
import { TabPanel } from "../../../components/TabPanel";
import { defaultScrollTheme } from "../../../utils/utils";
import PagesContainer from "../../../components/UI/PagesContainer";
import { useExtensionConfigs } from "../../../hooks/useExtensionConfigs";
import { Extension } from "../../../models/intalled-extensions";

interface IMySchedulesProps {
  isLinkAccess?: boolean;
}

const a11yProps = (index: number) => {
  return {
    id: `schedule-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const MySchedules = ({ isLinkAccess }: IMySchedulesProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { fetchExtensionConfig } = useExtensionConfigs();

  const [index, setIndex] = useState(0);

  const [whatsAppNumber, setWhatsAppNumber] = useState("");

  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      setIndex(newValue);
    },
    [],
  );

  const onClickAddButton = () => {
    navigate("/schedule/newSchedule");
  };

  const onClickScheduleButton = () => {
    const url = `https://wa.me/${whatsAppNumber}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const fetchWhatsAppNumber = useCallback(async () => {
    const configWhatsAppNumber = await fetchExtensionConfig(
      Extension.MY_SCHEDULES,
      "WhatsAppNumber",
    );

    if (configWhatsAppNumber?.value) {
      setWhatsAppNumber(configWhatsAppNumber.value);
    }
  }, [fetchExtensionConfig]);

  useEffect(() => {
    fetchWhatsAppNumber();
  }, [fetchWhatsAppNumber]);

  return (
    <PagesContainer
      title={t("page.schedules.mySchedules.title")}
      subtitle={t("page.schedules.mySchedules.subtitle")!}
      hideBackButton={isLinkAccess}
      rowActions={
        <>
          {!isLinkAccess && (
            <Button variant="contained" onClick={onClickAddButton}>
              {t("page.schedules.mySchedules.add")}
            </Button>
          )}

          {isLinkAccess && whatsAppNumber && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Button variant="contained" onClick={onClickScheduleButton}>
                {t("page.schedules.mySchedules.schedule")}
              </Button>
            </Box>
          )}
        </>
      }
    >
      <Tabs value={index} onChange={handleChange}>
        <Tab label={t("page.schedules.mySchedules.next")} {...a11yProps(0)} />
        <Tab
          label={t("page.schedules.mySchedules.historic")}
          {...a11yProps(1)}
        />
      </Tabs>
      <Box
        height={"calc(100% - 48px)"}
        overflow={"auto"}
        sx={defaultScrollTheme}
      >
        <TabPanel index={0} value={index} sx={{ padding: 0, paddingRight: 1 }}>
          <Schedules isLinkAccess={isLinkAccess} />
        </TabPanel>
        <TabPanel index={1} value={index} sx={{ padding: 0, paddingRight: 1 }}>
          <Schedules isLinkAccess={isLinkAccess} historic />
        </TabPanel>
      </Box>
    </PagesContainer>
  );
};

export default MySchedules;
